<template>
  <div class="container">
    <div class="icon_pc">
      <div class="customize_icon">
        <img src="@/icons/svg/tag-1.svg" />
      </div>
      <div class="customize_icon">
        <img src="@/icons/svg/tag-2.svg" />
      </div>
      <div class="customize_icon">
        <img src="@/icons/svg/tag-3-7~10.svg" />
      </div>
    </div>
    <div class="slide_bar">
      <agile
        :speed="1000"
        :timing="'linear'"
        :autoplay="true"
        :pauseOnHover="false"
      >
        <div class="slide slide-style">
          <img src="@/icons/svg/tag-1.svg" />
        </div>
        <div class="slide slide-style">
          <img src="@/icons/svg/tag-2.svg" />
        </div>
        <div class="slide slide-style">
          <img src="@/icons/svg/tag-3-4~7.svg" />
        </div>
      </agile>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import VueAgile from "@/components/agile_plugin.vue";
import "../../scss/_agile_plugin.scss";

export default {
  name: "customize",
  components: {
    // InfiniteSlideBar,
    agile: VueAgile,
  },
};
</script>

<style scoped lang="scss">
.container {
  padding-top: 80px;
}
.icon_pc {
  background-color: $primaryLightColor;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @include betweenPhoneTable {
    display: none;
  }
  .customize_icon {
    padding: 8px 10px 0 10px;
  }
}
</style>
